import { useDispatch } from "react-redux"
import CandidateSlice from "./slice"
import { useCallback, useEffect } from "react"

export const { refresh,setCandidate,setCandidateId ,refreshFile } =
	CandidateSlice.actions

export const useRefreshCandidate = () => {
	const dispatch = useDispatch()
	const refreshFn = useCallback(() => {
		dispatch(refresh())
	}, [dispatch])
	return {refresh:refreshFn}
}
export const useRefreshFile = () => {
	const dispatch = useDispatch()
	const refreshFn = useCallback(() => {
		dispatch(refreshFile())
	}, [dispatch])
	return {refresh:refreshFn}
}

export const useSetCandidate = (value) => {
	const dispatch = useDispatch()
	
	const setCandidateFn = useCallback(
		(value) => {
			dispatch(setCandidate(value))
			dispatch(setCandidateId(value?.id))
		},
		[dispatch],
	)

	useEffect(() => {
		if (!value) return
		setCandidateFn(value)
	}, [setCandidateFn, value])
	
	return {setCandidate:setCandidateFn}
}
export const useSetCandidateId = () => {
	const dispatch = useDispatch()
	const setCandidateIdFn = useCallback(
		(value) => {
			dispatch(setCandidateId(value))
		},
		[dispatch],
	)
	return {setCandidateId:setCandidateIdFn}
}
